import axious from "axios";

const axios = axious.create({
 baseURL:"https://695a9ee0950475ada4673ce1.mockapi.io/"
});

export default axios;  
